var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60958 10.3123C2.43708 10.0967 2.47204 9.78205 2.68767 9.60955L8.00002 5.35967L13.3124 9.60955C13.528 9.78205 13.563 10.0967 13.3905 10.3123C13.2179 10.528 12.9033 10.5629 12.6877 10.3904L8.00002 6.64029L3.31237 10.3904C3.09673 10.5629 2.78209 10.528 2.60958 10.3123Z",
    fill: "#2D3958"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShevronUp);
export default __webpack_public_path__ + "static/media/shevron-up.bc7584011555a5155e8fe92c882b91d5.svg";
export { ForwardRef as ReactComponent };